const data = {
  pageName: "Dsl2vdsl",
  asset: {
    Dimension: "[Dimension:1480291611621(el_GR)]",
    "Dimension-parent": [
      {
        group: "Locale",
        parent: { id: 1490638990008, type: "ContentInstanceAsset" }
      }
    ],
    LinkMap: null,
    Publist: ["Vodafone"],
    Relationships: [],
    SegRating: [],
    Webreference: [{}],
    c2aAssets: [],
    callinglist: "r_cbu_retention_dcvm",
    click2callButtons: null,
    clicktocallid: "test",
    clicktocallphone: "2106703669",
    clicktocallversion: "new",
    clicktocallcalendar: "cbu",
    createdby: "fwadmin",
    createddate: "2019-08-09T11:49:23+0000",
    defaultImage: null,
    description: "",
    enddate: null,
    externaldoctype: "",
    filename: "",
    flexBackgroundImage: null,
    formAction: null,
    formElAttributes: null,
    formId: "Retention_Consumer_LCM_Mobile"
  },
  services: {
    translations: {
      url: "offers/dsl2vdsl/translations",
      params: {}
    },
    createServiceRequest: {
      url: "offers/dsl2vdsl/createServiceRequest",
      params: {}
    },
    checkAvailability: {
      url: "offers/dsl2vdsl/checkAvailability",
      params: {}
    },
    getProductRecommendation: {
      url: "offers/dsl2vdsl/getProductRecommendation",
      params: {}
    },
    getJourneyConfig: {
      url: "offers/dsl2vdsl/getJourneyConfig",
      params: {}
    },
    createProductOrder: {
      url: "offers/dsl2vdsl/createProductOrder",
      params: {}
    },
    checkClickToCallRequest: {
      url: "clickToCall/checkClickToCallRequest",
      params: {}
    },
    checkClickToCallAvailability: {
      url: "clickToCall/checkClickToCallAvailability"
    }
  },

  externalLinks: {
    askHelp: "/exypiretisi/my-vodafone/ananeosi-symvolaiou/",
    otpPage: "/ananeosi-statheris/"
  }
};
exports.data = data;
